// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Base element styles (body, links, shared utilities).
 */

html {
  /* Bootstrap's rem-based sizes (.form-control, .btn, ...) resolve against
     this. Match body's 14px so they align with the px-based sidebar/header. */
  font-size: 87.5%;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Noto Sans",
    "Hiragino Kaku Gothic ProN", "Hiragino Sans", Meiryo, Helvetica, Arial,
    sans-serif;
  background-color: var(--gh-canvas-subtle);
  color: var(--gh-fg-default);
  font-size: 14px;
}

a {
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.text-muted-gh {
  color: var(--gh-fg-muted);
}
`, "",{"version":3,"sources":["webpack://./src/styles/base.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE;8EAC4E;EAC5E,gBAAgB;AAClB;;AAEA;EACE;;cAEY;EACZ,yCAAyC;EACzC,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/*\n * Base element styles (body, links, shared utilities).\n */\n\nhtml {\n  /* Bootstrap's rem-based sizes (.form-control, .btn, ...) resolve against\n     this. Match body's 14px so they align with the px-based sidebar/header. */\n  font-size: 87.5%;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Noto Sans\",\n    \"Hiragino Kaku Gothic ProN\", \"Hiragino Sans\", Meiryo, Helvetica, Arial,\n    sans-serif;\n  background-color: var(--gh-canvas-subtle);\n  color: var(--gh-fg-default);\n  font-size: 14px;\n}\n\na {\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n}\n\n.text-muted-gh {\n  color: var(--gh-fg-muted);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
